export const PageContent = ({ children }) => {
    return <div className="p-4">{children}</div>;
};